import { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import {
  PRODUCT_DESCRIPTION_MAX_CHARS,
  PRODUCT_NAME_MAX_CHARS,
  UNIFIED_FIELD,
} from 'src/data/brief';
import { GENERATION_TOOL, GENERATION_TOOL_LPCO } from 'src/data/generationTool';

import {
  DEFAULT_INPUT_PROPS,
  MULTILINE_ROWS_LIMIT_SECOND_FIELD,
  MULTILINE_ROWS_SECOND_FIELD,
  WTM_MULTILINE_ROWS_SECOND_FIELD,
} from '../../const';

import { FormProductField } from './FormProductField';
import { useStyles } from './useStyles';

export const FormProduct = ({
  className,
  classes,
  generationTool,
  content,
  onFieldChange,
  onFieldFocus,
  onFieldBlur,
  errors,
  disabled,
  limitMultilineMaxRows,
}) => {
  const styles = useStyles({ classes });
  const commonProps = {
    className: styles.field,
    generationTool,
    content,
    disabled,
    errors,
    onChange: onFieldChange,
  };

  const rows = useMemo(
    () =>
      Object.values(GENERATION_TOOL_LPCO).includes(generationTool)
        ? WTM_MULTILINE_ROWS_SECOND_FIELD
        : MULTILINE_ROWS_SECOND_FIELD,
    [generationTool]
  );

  return (
    <div className={cx(styles.root, className)}>
      <FormProductField
        {...commonProps}
        InputProps={{
          ...DEFAULT_INPUT_PROPS,
          onFocus: onFieldFocus,
          onBlur: onFieldBlur,
          multiline: false,
        }}
        maxChars={PRODUCT_NAME_MAX_CHARS}
        name={UNIFIED_FIELD.title}
      />

      <FormProductField
        {...commonProps}
        InputProps={{
          ...DEFAULT_INPUT_PROPS,
          onFocus: onFieldFocus,
          onBlur: onFieldBlur,
          rows,
          rowsMin: 4,
          rowsMax: limitMultilineMaxRows ? MULTILINE_ROWS_LIMIT_SECOND_FIELD : null,
        }}
        maxChars={PRODUCT_DESCRIPTION_MAX_CHARS}
        name={UNIFIED_FIELD.article}
      />
    </div>
  );
};

FormProduct.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape(),
  generationTool: PropTypes.oneOf(Object.values(GENERATION_TOOL)).isRequired,
  content: PropTypes.shape().isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFieldFocus: PropTypes.func,
  onFieldBlur: PropTypes.func,
  errors: PropTypes.shape(),
  disabled: PropTypes.bool,
  limitMultilineMaxRows: PropTypes.bool,
};

FormProduct.defaultProps = {
  className: null,
  classes: null,
  onFieldFocus: null,
  onFieldBlur: null,
  errors: null,
  disabled: false,
  limitMultilineMaxRows: false,
};
